import { render, staticRenderFns } from "./ImageUploder.vue?vue&type=template&id=fbc2d650&scoped=true"
import script from "./ImageUploder.vue?vue&type=script&lang=js"
export * from "./ImageUploder.vue?vue&type=script&lang=js"
import style0 from "./ImageUploder.vue?vue&type=style&index=0&id=fbc2d650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc2d650",
  null
  
)

export default component.exports